<template>
  <div class="mt-2">
    <div class="col-12 p-0">
      <i class="material-icons float-right pr-2" @click="savePDF">picture_as_pdf</i>
      <h2 class="block-header" data-toggle="collapse" href="#cutting" role="button" aria-expanded="true" aria-controls="cutting">
        Раскрой
      </h2>
    </div>
    <div class="col-12 align-self-center collapse show" id="cutting">
      <div ref="print" id="page">
        <div class="pageWrapper">
          <div class="page pt-4">
            <div class="row info m-0 pt-2">
              <div class="col"><b>Заказ №:</b> {{ orderActive.id }}</div>
              <div class="col"><b>Дата заявки:</b> {{ orderActive.created_at ? new Date(orderActive.created_at).toLocaleString('ru-RU') : ''}}</div>
              <div class="col"><b>Дата готовности:</b> {{ orderActive.ready_at ? new Date(orderActive.ready_at).toLocaleString('ru-RU') : '' }}</div>
              <div class="col"><b>Категория:</b> {{ orderActive.configuration ? orderActive.configuration.name : '' }}</div>
              <div class="col"><b>Количество:</b> {{ orderActive.count }}</div>
            </div>
            <div class="row info ml-0 mr-0 mt-0 mb-2">
              <div class="col-4"><b>Ткань:</b> {{ inside }}</div>
              <div class="col-4"><b>Подклад:</b> {{ outside }}</div>
              <div class="col-4"><b>Стенки:</b> {{ layer('walls') }}</div>
              <div class="col-4"><b>Дно:</b> {{ layer('bottom') }}</div>
              <div class="col-4"><b>Крышка:</b> {{ layer('top') }}</div>
              <div class="col-4"><b>Перегородки:</b> {{ layer('partitions') }}</div>
            </div>
            <div class="row info-grips ml-0 mr-0 mt-0 mb-2">
              <div class="col-4"><b>Лента для ручек:</b> {{ gripLength }} см</div>
              <div class="col-4"><b>Между ручками:</b> {{ gripBottom }} см</div>
              <div class="col-4"><b>Ремень:</b> {{ configuration.data.gripsExtra ? 'да' : 'нет' }}</div>
            </div>
            <div class="row info ml-0 mr-0 mt-0 mb-2">
              <div class="col-4"><b>Клиент:</b> {{ orderActive.name }} {{ orderActive.email }} {{ orderActive.phone }}</div>
              <div class="col-4"><b>Комментарий:</b> {{ orderActive.comment }}</div>
              <div class="col-4"><b>Заметка:</b> {{ orderActive.comment_admin }}</div>
            </div>
            <Part v-for="part in partsForFirstPage" :key="part.index" :index="part.index" :width="380" :height="150" :group="part.group" :info="part.info"/>
          </div>
        </div>
        <div class="pageWrapper" v-for="(pageParts, index) in partsForPages" :key="index">
          <div class="page pt-2">
            <Part v-for="part in pageParts" :key="part.index" :index="part.index" :width="380" :height="150" :group="part.group" :info="part.info"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Konva from 'konva';
import Part from './Part';
import jsPDF from 'jspdf' ;
import domtoimage from 'dom-to-image';

class Cut {
  constructor(configuration, sizes) {
    this.configuration = configuration;
    this.sizes = sizes;
    this.width = 360;
    this.height = 150;
    this.groups = [];
    this.sections = [];
    this.borders = this.calculateBorders();
    this.calculateMainParts();
    this.pockets();
    this.parts();
  }
  getDirectionText(direction) {
    switch(direction) {
      case 'bottom':
        return 'СНИЗУ';
      case 'top':
        return 'СВЕРХУ';
      case 'left':
        return 'СЛЕВА';
      case 'right':
        return 'СПРАВА';
      case 'back':
        return 'СЗАДИ';
      case 'front':
        return 'СПЕРЕДИ';
      default:
        return '';
    }
  }
  getPointsBySize(width, height) {
    return [
      0, 0,
      0, height,
      width, height,
      width, 0,
    ];
  }
  getPointsForAddingPart(points) {
    var width = 1.5;
    var height = points[3] - points[1];
    return this.getPointsBySize(width, height);
  }
  getPointsForPocketBottom(points) {
    var width = points[3] - points[1] + points[6] - points[0] + points[5] - points[7];
    var height = 5;
    return this.getPointsBySize(width, height);
  }
  getPointsByDirection(direction, scale=1) {
    var xN = 0;
    var yN = 0;
    switch (direction) {
      case 'bottom':
        xN = this.borders.x0 < 0 ? this.borders.x0 : 0;
        yN = this.borders.z0 < 0 ? this.borders.z0 : 0;
        return [
          (this.borders.x0 - xN) * scale, (this.borders.z0 - yN) * scale,
          (this.borders.x0 - xN) * scale, (this.borders.z - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.z - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.z0 - yN) * scale,
        ];
      case 'back':
        xN = this.borders.x0 < 0 ? this.borders.x0 : 0;
        yN = this.borders.y0 < 0 ? this.borders.y0 : 0;
        return [
          (this.borders.x0 - xN) * scale, (this.borders.y0 - yN) * scale,
          (this.borders.x0 - xN) * scale, (this.borders.y - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.y - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.y0 - yN) * scale,
        ];
      case 'right':
        xN = this.borders.z0 < 0 ? this.borders.z0 : 0;
        yN = this.borders.y0 < 0 ? this.borders.y0 : 0;
        return [
          (this.borders.z0 - xN) * scale, (this.borders.y0 - yN) * scale,
          (this.borders.z0 - xN) * scale, (this.borders.yf - yN) * scale,
          (this.borders.z - xN) * scale, (this.borders.y - yN) * scale,
          (this.borders.z - xN) * scale, (this.borders.y0 - yN) * scale,
        ];
      case 'front':
        xN = this.borders.x0 < 0 ? this.borders.x0 : 0;
        yN = this.borders.y0 < 0 ? this.borders.y0 : 0;
        return [
          (this.borders.x0 - xN) * scale, (this.borders.y0 - yN) * scale,
          (this.borders.x0 - xN) * scale, (this.borders.yf - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.yf - yN) * scale,
          (this.borders.x - xN) * scale, (this.borders.y0 - yN) * scale,
        ];
      case 'left':
        xN = this.borders.z0 < 0 ? this.borders.z0 : 0;
        yN = this.borders.y0 < 0 ? this.borders.y0 : 0;
        return [
          (this.borders.z0 - xN) * scale, (this.borders.y0 - yN) * scale,
          (this.borders.z0 - xN) * scale, (this.borders.y - yN) * scale,
          (this.borders.z - xN) * scale, (this.borders.yf - yN) * scale,
          (this.borders.z - xN) * scale, (this.borders.y0 - yN) * scale,
        ];
      case 'top':
        xN = this.borders.x0 < 0 ? this.borders.x0 : 0;
        yN = 0;
        return [
          (this.borders.x0 - xN) * scale, (0 - yN) * scale,
          (this.borders.x0 - xN) * scale, (Math.sqrt(Math.pow(this.borders.y - yN - this.borders.yf - yN, 2) + Math.pow(this.borders.z - xN - this.borders.z0 - xN, 2))) * scale,
          (this.borders.x - xN) * scale, (Math.sqrt(Math.pow(this.borders.y - yN - this.borders.yf - yN, 2) + Math.pow(this.borders.z -xN - this.borders.z0 - xN, 2))) * scale,
          (this.borders.x - xN) * scale, (0 - yN) * scale,
        ];
      default:
        return [];
    }
  }
  calculateBorders() {
    var borders = JSON.parse(JSON.stringify(this.configuration.sections[0]));
    this.configuration.sections.slice(1).forEach(section => {
      borders.x += section.x;
      borders.x0 -= section.x0;
      borders.y += section.z0 * (borders.y - borders.yf) / (borders.z - borders.z0) + section.y;
      borders.yf -= section.z * (borders.y - borders.yf) / (borders.z - borders.z0) - section.yf;
      borders.y0 -= section.y0;
      borders.z += section.z;
      borders.z0 -= section.z0;
      borders.direction = section.direction;
      this.sections.push(JSON.parse(JSON.stringify(borders)));
    });
    return borders;
  }
  calculateMainParts() {
    switch(this.configuration.grips) {
      case 'bottom-top':
        this.group1();
        this.group2();
        break;
      case 'front-back':
        this.group3();
        this.group4();
        break;
      case 'left-right':
        this.group3();
        this.group4();
        break;
    }
  }
  group1() {
    var group = new Konva.Group({ x: 0, y: 0 });
    var groupMesh = new Konva.Group({ x: 0, y: 0 });
    var groupText = new Konva.Group({ x: 0, y: 0 });

    // левая/передняя/правая стороны
    var groupWidth = this.width;
    var groupHeight = this.height;
    var x = 0;
    var y = 0;

    var pointsLeft = this.getPointsByDirection('left');
    var pointsFront = this.getPointsByDirection('front');
    var pointsRight = this.getPointsByDirection('right');
    var pointsAdding = this.getPointsForAddingPart(pointsLeft);

    var path = new Konva.Line({ points: pointsAdding, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;

    path = new Konva.Line({ points: pointsLeft, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'B', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    x = groupMesh.getClientRect().width - 2;

    path = new Konva.Line({ points: pointsFront, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'A', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'C2', x: x + 2, y: groupMesh.getClientRect().height - 14, fill: 'black' }));

    path = new Konva.Line({ points: pointsRight, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'B', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    x = groupMesh.getClientRect().width - 2;

    path = new Konva.Line({ points: pointsAdding, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'D', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'C1', x: x + 2, y: groupMesh.getClientRect().height - 14, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'D', x: 0, y: groupMesh.getClientRect().height, fill: 'black' }));

    groupMesh.offsetY(groupMesh.getClientRect().height - 2);

    var scale = Math.min(groupWidth / (groupMesh.getClientRect().width + 12), groupHeight / (groupMesh.getClientRect().height + 12));
    groupMesh.scaleX(scale);
    groupMesh.scaleY(-scale);
    groupText.children.forEach(child => {
      child.attrs.x = child.attrs.x * scale;
      child.attrs.y = child.attrs.y * scale;
    });

    group.add(groupMesh);
    group.add(groupText);

    this.groups.push({
      group: group,
      index: Math.random(),
      info: {
        'СЛЕВА + ПЕРЕД + СПРАВА': ['A', 'B', 'C1', 'C2', 'D'],
        'ткань': [this.sizes.A - 1.5, this.sizes.B, this.sizes.C1 - 2, this.sizes.C2 - 2, 1.5],
        'подклад': [this.sizes.A - 1.5, this.sizes.B, this.sizes.C1, this.sizes.C2, 1.5],
        'изолон': [this.sizes.A - 2, this.sizes.B - 2, this.sizes.C1 - 2, this.sizes.C2 - 2, '-'],
        'фанера': [this.sizes.A - 7, this.sizes.B - 7, this.sizes.C1 - 7, this.sizes.C2 - 7, '-'],
      },
    });
  }
  group2() {
    var group = new Konva.Group({ x: 0, y: 0 });
    var groupMesh = new Konva.Group({ x: 0, y: 0 });
    var groupText = new Konva.Group({ x: 0, y: 0 });

    // крышка - зад - дно
    var groupWidth = this.width;
    var groupHeight = this.height;
    var x = 0;
    var y = 0;

    var pointsTop = this.getPointsByDirection('top');
    var pointsBack = this.getPointsByDirection('back');
    var pointsBottom = this.getPointsByDirection('bottom');

    var path = new Konva.Line({ points: pointsTop, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'B', x: x / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));

    path = new Konva.Line({ points: pointsBack, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'C1', x: x - path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));

    path = new Konva.Line({ points: pointsBottom, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'B', x: x - path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'A', x: x + 6, y: groupMesh.getClientRect().height - 14, fill: 'black' }));

    var scale = Math.min(groupWidth / (groupMesh.getClientRect().width + 12), groupHeight / (groupMesh.getClientRect().height + 12));
    groupMesh.scaleX(scale);
    groupMesh.scaleY(scale);
    groupText.children.forEach(child => {
      child.attrs.x = child.attrs.x * scale;
      child.attrs.y = child.attrs.y * scale;
    });

    group.add(groupMesh);
    group.add(groupText);

    this.groups.push({
      group: group,
      index: Math.random(),
      info: {
        'КРЫШКА + ЗАД + ДНО': ['A', 'B', 'C1'],
        'ткань': [this.sizes.A, this.sizes.B, this.sizes.C1],
        'подклад': [this.sizes.A + 2, this.sizes.B + 1, this.sizes.C1 + 1],
        'изолон': [this.sizes.A - 2, this.sizes.B - 2, this.sizes.C1],
        'фанера': [this.sizes.A - 8, this.sizes.B - 8, this.sizes.C1],
      },
    });
  }
  group3() {
    var group = new Konva.Group({ x: 0, y: 0 });
    var groupMesh = new Konva.Group({ x: 0, y: 0 });
    var groupText = new Konva.Group({ x: 0, y: 0 });

    // перед - дно - зад
    var groupWidth = this.width;
    var groupHeight = this.height;
    var x = 0;
    var y = 0;

    var pointsFront = this.getPointsByDirection('front');
    var pointsBottom = this.getPointsByDirection('bottom');
    var pointsBack = this.getPointsByDirection('back');

    var path = new Konva.Line({ points: pointsFront, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'C1', x: x / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));

    path = new Konva.Line({ points: pointsBottom, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'B', x: x - path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));

    path = new Konva.Line({ points: pointsBack, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    path.rotate(90);
    path.offsetY(path.getClientRect().width);
    groupMesh.add(path);
    x = groupMesh.getClientRect().width - 2;
    groupText.add(new Konva.Text({ text: 'C2', x: x - path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'A', x: x + 6, y: groupMesh.getClientRect().height - 14, fill: 'black' }));

    var scale = Math.min(groupWidth / (groupMesh.getClientRect().width + 12), groupHeight / (groupMesh.getClientRect().height + 12));
    groupMesh.scaleX(scale);
    groupMesh.scaleY(scale);
    groupText.children.forEach(child => {
      child.attrs.x = child.attrs.x * scale;
      child.attrs.y = child.attrs.y * scale;
    });

    group.add(groupMesh);
    group.add(groupText);

    this.groups.push({
      group: group,
      index: Math.random(),
      info: {
        'ПЕРЕД + ДНО + ЗАД': ['A', 'B', 'C1', 'C2'],
        'ткань': [this.sizes.A, this.sizes.B, this.sizes.C1, this.sizes.C2],
        'подклад': [this.sizes.A + 2, this.sizes.B + 2, this.sizes.C1 + 2, this.sizes.C2 + 2],
        'изолон': [this.sizes.A - 2, this.sizes.B - 2, this.sizes.C1 - 2, this.sizes.C2 - 2],
        'фанера': [this.sizes.A - 7, this.sizes.B - 7, this.sizes.C1 - 7, this.sizes.C2 - 7],
      },
    });
  }
  group4() {
    var group = new Konva.Group({ x: 0, y: 0 });
    var groupMesh = new Konva.Group({ x: 0, y: 0 });
    var groupText = new Konva.Group({ x: 0, y: 0 });

    // крышка/слева/справа
    var groupWidth = this.width;
    var groupHeight = this.height;
    var x = 0;
    var y = 0;

    var pointsLeft = this.getPointsByDirection('left');
    var pointsTop = this.getPointsByDirection('top');
    var pointsRight = this.getPointsByDirection('right');

    var path = new Konva.Line({ points: pointsTop, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'A', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'B', x: path.getClientRect().width + 2, y: groupMesh.getClientRect().height - 14, fill: 'black' }));
    x = groupMesh.getClientRect().width + 10;

    path = new Konva.Line({ points: pointsLeft, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'D', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'C1', x: x + path.getClientRect().width + 2, y: groupMesh.getClientRect().height - 14, fill: 'black' }));
    x = groupMesh.getClientRect().width + 10;

    path = new Konva.Line({ points: pointsRight, stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
    groupMesh.add(path);
    groupText.add(new Konva.Text({ text: 'D', x: x + path.getClientRect().width / 2 - 2, y: groupMesh.getClientRect().height, fill: 'black' }));
    groupText.add(new Konva.Text({ text: 'C2', x: x + path.getClientRect().width + 2, y: groupMesh.getClientRect().height - 14, fill: 'black' }));
    x = groupMesh.getClientRect().width + 10;

    groupMesh.offsetY(groupMesh.getClientRect().height);

    var scale = Math.min(groupWidth / (groupMesh.getClientRect().width + 12), groupHeight / (groupMesh.getClientRect().height + 12));
    groupMesh.scaleX(scale);
    groupMesh.scaleY(-scale);
    groupText.children.forEach(child => {
      child.attrs.x = child.attrs.x * scale;
      child.attrs.y = child.attrs.y * scale + 4;
    });
    group.add(groupMesh);
    group.add(groupText);

    this.groups.push({
      group: group,
      index: Math.random(),
      info: {
        'КРЫШКА + СЛЕВА + СПРАВА': ['A', 'B', 'C1', 'C2', 'D'],
        'ткань': [this.sizes.A + 1, this.sizes.B + 1, this.sizes.C1 + 1, this.sizes.C2 + 1, this.sizes.B + 1.5],
        'подклад': [this.sizes.A + 1, this.sizes.B + 1, this.sizes.C1 + 2, this.sizes.C2 + 2, this.sizes.B + 1.5],
        'изолон': [this.sizes.A - 2, this.sizes.B - 2, this.sizes.C1 - 2, this.sizes.C2 - 2, this.sizes.B - 2],
        'фанера': [this.sizes.A - 7, this.sizes.B - 7, this.sizes.C1 - 7, this.sizes.C2 - 7, this.sizes.B - 7],
      },
    });
  }
  pockets() {
    var pocketsInside = JSON.parse(JSON.stringify(this.configuration.pockets.filter(x => x.inside == true)));
    pocketsInside.forEach(pocket => pocket.outside = false);
    var pocketsOutside = JSON.parse(JSON.stringify(this.configuration.pockets.filter(x => x.outside == true)));
    pocketsOutside.forEach(pocket => pocket.inside = false);
    var pockets = pocketsInside.concat(pocketsOutside);

    if (pockets.length > 0) {
      var pointsPockets = [];
      for (let i = 0; i < pockets.length; i++) {
        pointsPockets.push(this.getPointsByDirection(pockets[i].direction, 0.8));
      }

      for (let i = 0; i < pointsPockets.length; i++) {
        var group = new Konva.Group({ x: 0, y: 0 });
        var groupMesh = new Konva.Group({ x: 0, y: 0 });
        var groupText = new Konva.Group({ x: 0, y: 0 });
        var x = 0;
        var y = 0;

        var path = new Konva.Line({ points: pointsPockets[i], stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
        path.scaleY(-1);
        path.offsetY(path.getClientRect().height);
        groupMesh.add(path);
        path = new Konva.Line({ points: this.getPointsBySize(groupMesh.getClientRect().width - 2, 5), stroke: 'black', strokeWidth: 1, closed: true, x: 0, y: groupMesh.getClientRect().height, strokeScaleEnabled: false });
        groupMesh.add(path);
        x = groupMesh.getClientRect().width;
        y = groupMesh.getClientRect().height;
        groupText.add(new Konva.Text({ text: 'A', x: x / 2 - 2, y: y + 2, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'B1', x: 2, y: y - 12, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'B2', x: x, y: y - 12, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'C', x: x, y: y - 4, fill: 'black' }));
        x = 0;
        y += 8;

        path = new Konva.Line({ points: this.getPointsForPocketBottom(pointsPockets[i]), stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
        groupMesh.add(path);
        x = groupMesh.getClientRect().width;
        y = groupMesh.getClientRect().height;
        groupText.add(new Konva.Text({ text: 'D', x: x / 2 - 2, y: y + 2, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'E', x: x, y: y - 4, fill: 'black' }));

        var scale = Math.min(this.width / (groupMesh.getClientRect().width + 12), this.height / (groupMesh.getClientRect().height + 12));
        groupMesh.scaleX(scale);
        groupMesh.scaleY(scale);
        groupText.children.forEach(child => {
          child.attrs.x = child.attrs.x * scale;
          child.attrs.y = child.attrs.y * scale;
        });

        group.add(groupMesh);
        group.add(groupText);

        var info = {};
        var location = pockets[i].inside ? 'ВНУТРИ ' : 'СНАРУЖИ ';
        var name = 'КАРМАН ' + location + this.getDirectionText(pockets[i].direction);
        info[name] = ['A', 'B1', 'B2', 'C', 'D', 'E']
        var A = pointsPockets[i][6] - pointsPockets[i][0];
        var B1 = pointsPockets[i][3] - pointsPockets[i][1];
        var B2 = pointsPockets[i][5] - pointsPockets[i][7];
        var D = A + B1 + B2;
        var material = pockets[i].inside ? 'подклад ' : 'ткань ';
        info[material] = [A, B1, B2, 5, D, 6];
        info['подклад'] = [A + 1, B1 + 1, B2 + 1, 5 + 1, D + 1, 6 + 1];
        info['изолон'] = [A - 1, B1 - 1, B2 - 1, 5 - 1, D - 1, 6 - 1];
        this.groups.push({
          group: group,
          index: Math.random(),
          info: info,
        });
      }
    }
  }
  parts() {
    if (this.sections.length > 0) {
      var pointsSections = [];
      for (let i = 0; i < this.sections.length; i++) {
        pointsSections.push(this.getPointsByDirection(this.sections[i].direction, 0.8));
      }

      for (let i = 0; i < pointsSections.length; i++) {
        var group = new Konva.Group({ x: 0, y: 0 });
        var groupMesh = new Konva.Group({ x: 0, y: 0 });
        var groupText = new Konva.Group({ x: 0, y: 0 });
        var x = 0;
        var y = 0;

        var path = new Konva.Line({ points: pointsSections[i], stroke: 'black', strokeWidth: 1, closed: true, x: x, y: y, strokeScaleEnabled: false });
        path.scaleY(-1);
        path.offsetY(path.getClientRect().height);
        groupMesh.add(path);
        x = groupMesh.getClientRect().width;
        y = groupMesh.getClientRect().height;
        groupText.add(new Konva.Text({ text: 'A', x: x / 2 - 2, y: y + 2, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'B1', x: 2, y: y - 8, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'B2', x: x, y: y - 8, fill: 'black' }));
        path = new Konva.Line({ points: pointsSections[i], stroke: 'black', strokeWidth: 1, closed: true, x: 0, y: y, strokeScaleEnabled: false });
        groupMesh.add(path);
        groupText.add(new Konva.Text({ text: 'C1', x: 2, y: y + 8, fill: 'black' }));
        groupText.add(new Konva.Text({ text: 'C2', x: x, y: y + 8, fill: 'black' }));

        var scale = Math.min(this.width / (groupMesh.getClientRect().width + 12), this.height / (groupMesh.getClientRect().height + 12));
        groupMesh.scaleX(scale);
        groupMesh.scaleY(scale);
        groupText.children.forEach(child => {
          child.attrs.x = child.attrs.x * scale;
          child.attrs.y = child.attrs.y * scale;
        });

        group.add(groupMesh);
        group.add(groupText);

        var info = {};
        var name = 'ПЕРЕГОРОДКА ' + this.getDirectionText(this.sections[i].direction);
        info[name] = ['A', 'B1', 'B2', 'C1', 'C2']
        var extra = this.configuration.layers.partitions == 0 ? 1 : 2;
        var A = pointsSections[i][6] - pointsSections[i][0];
        var B1 = pointsSections[i][3] - pointsSections[i][1];
        var B2 = pointsSections[i][5] - pointsSections[i][7];
        info['подклад'] = [A + extra, B1 + extra, B2 + extra, B1 + extra, B2 + extra];
        info['изолон'] = [A - 1, B1 - 1, B2 - 1, '-', '-'];
        info['фанера'] = [A - 6, B1 - 6, B2 - 6, '-', '-'];
        this.groups.push({
          group: group,
          index: Math.random(),
          info: info,
        });
      }
    }    
  }
}

export default {
  name: "Cutting",
  props: {
    configuration: Object,
    orderActive: Object,
    materials: Array,
  },
  data() {
    return {
      stage: Object,
      width: 810,
      height: 1188,
      parts: [],
      pages: [],
      doc: Object,
      lastPage: false,
    }
  },
  watch: {
    configuration: {
      handler() {
        this.updateMesh();
      },
      deep: true,
    },
  },
  computed: {
    A() {
      var x = 0;
      var x0 = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        x += layer.x;
        x0 += layer.x0;
        if (layer.x > 0 || layer.x0 > 0)
          layersCount += 1;
      })
      return x + x0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount;
    },
    B() {
      var z = 0;
      var z0 = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        z += layer.z;
        z0 += layer.z0;
        if (layer.z > 0 || layer.z0 > 0)
          layersCount += 1;
      })
      return z + z0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount;
    },
    C1() {
      var y = 0;
      var y0 = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        y += layer.y;
        y0 += layer.y0;
        if (layer.y > 0 || layer.y0 > 0 || layer.yf)
          layersCount += 1;
      })
      return y + y0 + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount;
    },
    C2() {
      var y0 = 0;
      var yf = 0;
      var layersCount = -1;
      this.configuration.data.sections.forEach(layer => {
        y0 += layer.y0;
        yf += layer.yf;
        if (layer.y > 0 || layer.y0 > 0 || layer.yf)
          layersCount += 1;
      })
      return y0 + yf + (this.configuration.data.layers.partitions == 0 ? 1 : 2) * layersCount;
    },
    partsForFirstPage() {
      return this.parts.slice(0, 5);
    },
    partsForPages() {
      var pages = [];
      for (let i = 5; i < this.parts.length; i += 7) {
        pages.push(this.parts.slice(i, i + 7));
      }
      return pages;
    },
    inside() {
      var material = 'Жёлтый велюр';
      this.materials.forEach(m => {
        if (m.id == this.configuration.data.materials.inside)
          material = m.name;
      });
      return material;
    },
    outside() {
      var material = 'Чёрный оксфорд';
      this.materials.forEach(m => {
        if (m.id == this.configuration.data.materials.outside)
          material = m.name;
      });
      return material;
    },
    gripLength() {
      var extra = this.gripBottom * Math.PI;
      var length1 = 0;
      var length2 = 0;
      var length3 = 0;
      switch(this.configuration.data.grips) {
        case 'bottom-top':
          length1 = this.B;
          length2 = this.C1;
          length3 = Math.sqrt(Math.pow(this.B, 2) + Math.pow(Math.abs(this.C1 - this.C2), 2));
          break;
        case 'front-back':
          length1 = this.C1;
          length2 = this.B;
          length3 = this.C2;
          break;
        case 'left-right':
          length1 = this.C1;
          length2 = this.A;
          length3 = this.C1;
          break;
      }
      return Math.ceil((length1 + length2 + length3) * 2 + extra);
    },
    gripBottom() {
      var width = 0;
      switch(this.configuration.data.grips) {
        case 'bottom-top':
          width = this.A;
          break;
        case 'front-back':
          width = this.A;
          break;
        case 'left-right':
          width = this.B;
          break;
      }
      if (width > 34)
        return 24;
      else
        return 20;
    },
  },
  methods: {
    init() {
      this.updateMesh();
    },
    updateMesh() {
      this.parts = [];

      var sizes = {
        A: this.A,
        B: this.B,
        C1: this.C1,
        C2: this.C2,
      }
      var cut = new Cut(this.configuration.data, sizes);
      cut.groups.forEach(group => {
        this.parts.push(group);
      });
    },
    layer(layer) {
      if (this.configuration.data.layers[layer] == 0)
        return 'изолон 10мм';
      else if (this.configuration.data.layers[layer] == 1)
        return 'изолон 10мм + фанера 3мм + изолон 10мм';
      else
        return 'изолон 10мм + изолон 10мм';
    },
    // PDF
    addPage(dataUrl) {
      this.doc.addImage(dataUrl, 'PNG', 0, 0);
      if (this.lastPage) 
        this.download();
      else {
        this.doc.addPage();
        this.recursiveRender();
      }
    },
    download() {
      var name = this.orderActive.id ? `Заказ №${this.orderActive.id} - раскрой.pdf` : `${(new Date()).toLocaleString('ru')} - раскрой.pdf`;
      this.doc.save(name);
    },
    recursiveRender() {
      var page = this.pages.shift();
      if (this.pages.length == 0)
        this.lastPage = true;
      domtoimage.toPng(page).then(this.addPage);
    },
    savePDF() {
      this.doc = new jsPDF();
      this.lastPage = false;
      this.pages = Array.from(document.getElementsByClassName("page"));
      this.recursiveRender();
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Part,
  },
}
</script>

